import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {useNavigate, useParams} from "react-router-dom";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {AutoComplete} from "primereact/autocomplete";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

const _FM_ReservationBillingdataFormComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [countries, setCountries] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customersOrig, setCustomersOrig] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState('');

  const resolveCityFromZipCode = (zipCode) => {
    const normalizedZipCode = String(zipCode || '').trim();
    if (normalizedZipCode.length < 4) {
      return;
    }
    window.App.zipCode(normalizedZipCode, (city) => {
      setFormData(prev => ({
        ...prev,
        city: city || '',
      }));
    });
  };

  useEffect(() => {
    if(props.billingData) {
      setFormData(props.billingData)
      setSelectedCustomer(props.billingData?.name_or_company_name || '')
    }
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "dictionary/country",
      params: {},
      headers: {
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        const allCountries = response.data.data;
        const prioritizedCountries = JSON.parse(process.env.REACT_APP_PRIORITIZEDCOUNTRIES || "[]");
        const sortedCountries = [
          ...allCountries.filter((country) => prioritizedCountries.includes(country.code)),
          ...allCountries.filter((country) => !prioritizedCountries.includes(country.code)),
        ];
        setCountries(sortedCountries);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
  }, [])

  const setBillingDataFromCustomer = (customer) => {
    setFormData((prevState) => ({
      ...prevState,
      name_or_company_name: `${customer?.lastname ?? ''} ${customer?.firstname ?? ''}`.trim(),
      vat_number: '',
      email: '',
      country: customer?.residence_country?.toUpperCase(),
      zip_code: customer?.zip_code,
      city: '',
      street_and_number: customer?.address,
    }));
    resolveCityFromZipCode(customer?.zip_code);
  };

  const getAutoCompleteDisplayValue = (value) => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      return value;
    }
    return value?.name || '';
  };

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('billing')}</h2>
        </div>
        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
          <Button type="button"
                  disabled={!props.uniqueId || !props.password}
                  onClick={() => {
                    delete formData.id;
                    delete formData._class_name;
                    delete formData._country_specifics;
                    delete formData._under_edit_by;
                    delete formData._under_edit_by_name_snap;
                    delete formData._under_edit_from;
                    delete formData.created_at_snapshot;
                    delete formData.updated_at_snapshot;
                    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                      + "public/reservation/"
                      + props.uniqueId + "/" + props.password,
                      {
                        default_billing_data: formData,
                      },
                      {
                        params: {},
                        headers: {
                          "Sys-name": Cookies.get("instanceId"),
                          "Preferred-locale": Cookies.get("language")
                        }
                      })
                      .then(response => {
                        setLoading(false)
                        window.App.toastShow('success', t('success'), response.data.message)
                      })
                      .catch(error => {
                        setLoading(false)
                        window.App.toastShow('error', t('error'), error.response.data.message,
                          '', error.response)
                      })
                  }}
                  label={t('save')}
                  loading={loading}
                  icon={"pi pi-save"}
                  className="p-button-success p-ml-2"/>
        </div>
      </div>

      <div className={"billing"}>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6"}>
            <div className="p-field p-fluid">
              <label htmlFor="name_or_company_name">{t('name_or_company_name')}</label>
              <span className="p-d-block">
                <AutoComplete value={selectedCustomer}
                              id={"name_or_company_name"}
                              suggestions={customers}
                              dropdown
                              completeMethod={(e) => {
                                axios({
                                  method: 'get',
                                  url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST
                                    + "customer??direction=desc&item_per_page=9999&search[firstname%2Blastname][operator]=like&search[firstname%2Blastname][value]=*"
                                    + e.query + "*&sort=id",
                                  params: {},
                                  headers: {
                                    'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                    "Sys-name": Cookies.get("instanceId"),
                                    "Preferred-locale": Cookies.get("language")
                                  }
                                })
                                  .then(response => {
                                    if (response.data.data.items && response.data.data.items[0]) {
                                      setCustomersOrig(response.data.data.items)
                                      const _customers = []
                                      response.data.data.items.map((customer) => {
                                        if (customer.firstname && customer.zip_code && customer.address) {
                                          _customers.push({
                                            id: customer.id,
                                            name: customer.lastname + ' ' + customer.firstname + ' - ' + customer.zip_code + ' ' + customer.address,
                                          })
                                        }
                                        if (customer.firstname && !customer.zip_code && !customer.address) {
                                          _customers.push({
                                            id: customer.id,
                                            name: customer.firstname,
                                          })
                                        }
                                        if (!customer.firstname && !customer.zip_code && !customer.address) {
                                          _customers.push({
                                            id: customer.id,
                                            name: customer.id,
                                          })
                                        }
                                      })
                                      setCustomers(_customers);
                                    } else {
                                      setCustomers([])
                                    }
                                  })
                                  .catch(error => {
                                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                  })
                              }}
                              field={"name"}
                              delay="1000"
                              placeholder={t('type_to_search')}
                              onSelect={(e) => {
                                const customer = customersOrig.find(item => item.id === e?.value?.id)
                                setSelectedCustomer(getAutoCompleteDisplayValue(e?.value))
                                setBillingDataFromCustomer(customer)
                              }}
                              onChange={(e) => {
                                const displayValue = getAutoCompleteDisplayValue(e?.value)
                                setSelectedCustomer(displayValue)
                                const customer = customersOrig.find(item => item.id === e?.value?.id)
                                if (customer) {
                                  setBillingDataFromCustomer(customer)
                                  return;
                                }
                                setFormData((prevState) => ({
                                  ...prevState,
                                  name_or_company_name: displayValue,
                                }));
                              }}
                              onClear={() => {
                                setSelectedCustomer('')
                                setFormData((prevState) => ({
                                  ...prevState,
                                  name_or_company_name: '',
                                  country: null,
                                  zip_code: '',
                                  street_and_number: '',
                                }));
                              }}
                />
                        </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-2"}>
            <div className="p-field p-fluid">
              <label htmlFor="vat_number">{t('vat_number')}</label>
              <span className="p-d-block">
                          <InputText id="vat_number"
                                     onChange={(e) => {
                                       setFormData({
                                         ...formData,
                                         vat_number: e.target.value
                                       })
                                     }}
                                     value={formData?.vat_number}
                          />
                        </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="email">{t('email')}</label>
              <span className="p-d-block">
                          <InputText id="email"
                                     onChange={(e) => {
                                       setFormData({
                                         ...formData,
                                         email: e.target.value
                                       })
                                     }}
                                     value={formData?.email}
                          />
                        </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-2"}>
            <div className="p-field p-fluid">
              <label htmlFor="country">{t('country')}</label>
              <span className="p-d-block">
                          <Dropdown  options={countries}
                                    filter
                                    optionLabel="name"
                                    optionValue="code"
                                    id={"country"}
                                    emptyMessage={t('empty_message')}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        country: e.value
                                      })
                                    }}
                                    value={formData?.country}
                          />
                        </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-2"}>
            <div className="p-field p-fluid">
              <label htmlFor="zip_code">{t('zip_code')}</label>
              <span className="p-d-block">
                          <InputText id="zip_code"
                                     onChange={(e) => {
                                       setFormData({
                                         ...formData,
                                         zip_code: e.target.value
                                       })
                                       resolveCityFromZipCode(e.target.value)
                                     }}
                                     value={formData?.zip_code}
                          />
                        </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-3"}>
            <div className="p-field p-fluid">
              <label htmlFor="city">{t('city')}</label>
              <span className="p-d-block">
                          <InputText id="city"
                                     onChange={(e) => {
                                       setFormData({
                                         ...formData,
                                         city: e.target.value
                                       })
                                     }}
                                     value={formData?.city}
                          />
                        </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-5"}>
            <div className="p-field p-fluid">
              <label htmlFor="street_and_number">{t('street_and_number')}</label>
              <span className="p-d-block">
                          <InputText id="street_and_number"
                                     onChange={(e) => {
                                       setFormData({
                                         ...formData,
                                         street_and_number: e.target.value
                                       })
                                     }}
                                     value={formData?.street_and_number}
                          />
                        </span>
            </div>
          </div>
          {/*<div className={"p-col-12 p-lg-12"}>*/}
          {/*  <div className="p-field p-fluid">*/}
          {/*    <label htmlFor="note">{t('note')}</label>*/}
          {/*    <span className="p-d-block">*/}
          {/*                <InputText id="note"*/}
          {/*                           onChange={(e) => {*/}
          {/*                             setFormData({*/}
          {/*                               ...formData,*/}
          {/*                               note: e.target.value*/}
          {/*                             })*/}
          {/*                           }}*/}
          {/*                           value={formData?.note}*/}
          {/*                />*/}
          {/*              </span>*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
      </div>

    </>
  )
}
export default withTranslation('common')(_FM_ReservationBillingdataFormComponent);
